import "./MenuVtc.css";
import { manualdownload, toHomePageUrl } from "../../../Api/SubUrl";
import { Path } from "../../../Api/Path";
import useClientAuthSession from "../../../Hooks/useClientAuthSession";
const ZALO_GROUP_URL = process.env.REACT_APP_ZALO_SUPPORT_GROUP_URL;

function MenuVTC() {
    const { isAuthenticated } = useClientAuthSession();

  if (!isAuthenticated) return null;

  return (
    <div className="content-right">
      <div className="inner">
        <a
          href={toHomePageUrl(manualdownload)}
          className="download"
          aria-label="Tải xuống"
          rel="noopener noreferrer"
        ></a>

        <a
          href={ZALO_GROUP_URL}
          className="trade"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Zalo"
        ></a>

        <a
          href={Path.Fanpage}
          className="fanpage"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fanpage"
        ></a>

        <a
          href={Path.Group}
          className="group"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Nhóm"
        ></a>

        <button
          type="button"
          className="totop"
          id="totop"
          aria-label="Lên đầu trang"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        ></button>
      </div>
    </div>
  );
}
export default MenuVTC;
